<template lang="pug">
ul.inner-list.choices.with_indentation
  li(v-for="(choice, idx) in rso.section_option.choices" :class="{disabled: isDisabled(choice)}")
    label(:for="rso.section_option.id+'_choice_'+idx")
        .columns.large-12
            validation-provider.content(v-slot="{ errors }" :rules="{required: rso.section_option.required}")
                .checkbox-holder(v-if="rso.section_option.multiple_choices || rso.section_option.automatically_applied")
                    input.no-custom(
                        type="checkbox",
                        :id="rso.section_option.id+'_choice_'+idx",
                        :required="rso.section_option.required && editing_as_a_family",
                        :data-changer="editing_as_an_org ? 'organization' : 'user'",
                        v-model="rso.choice_ids",
                        :value="choice.id"
                        @change="makeDelete"
                        :disabled="isReadOnly(choice)"
                    )
                    span.label-text
                .checkbox-holder(v-else)
                    // next line is to support vee-validate
                    input.hidden(type="radio" v-model="rso.choice_ids[0]" :value="choice.id")
                    input.no-custom(
                        type="radio",
                        :value="choice.id",
                        :checked="rso.choice_ids[0] === choice.id"
                        @click="radioClick(choice.id)",
                        :id="rso.section_option.id+'_choice_'+idx",
                        :data-changer="editing_as_an_org ? 'organization' : 'user'",
                        :required="rso.section_option.required && editing_as_a_family"
                        :disabled="isReadOnly(choice)"
                        :name="'section_options_'+rso.section_option.id"
                    )
                    span.label-text
                .label-text(:class="{error: errors[0]}")
                    strong {{ choice.name }}
        .columns.large-4
            small.space_limit.gray(v-if="rso.section_option.show_space_limit && has_space(choice)")
                | {{ t('app.program.spaces_left', {spaces: available_spaces(choice)}) }}
            small.space_limit.gray(v-if="!has_space(choice)")
                | {{ t('app.general.full') }}
        .columns.large-6
            .price {{ get_section_fee(registration.program.display_fee_type, choice.amount, rso.section_option.currency) }}
    .clearfix
</template>
<script>
import helpers from '../../helper'
import edit_helper from 'templates/registrations/edit_helper'
import {ValidTodayAbility} from "models/concerns/valid_today_ability"
import {Addon} from "models/addon";
export default {
  mixins: [helpers, edit_helper],
  props: ['rso'],
  mounted(){
    if (this.rso.section_option.automatically_applied && this.ability.valid_today()){
      for (let choice of this.rso.section_option.choices){
        if(this.rso.choice_ids.includes(choice.id)) continue;
        this.rso.choice_ids.push(choice.id)
      }
    }
    for (let choice of this.rso.section_option.choices){
      if (!this.current_organization.id && !this.has_space(choice) && this.registration.isStillPending()){
        const index = this.rso.choice_ids.indexOf(choice.id);
        if (index !== -1) this.rso.choice_ids.splice(index, 1)
      }
    }
    this.makeDelete()
  },
  methods: {
    radioClick(id) {
      if (this.rso.choice_ids[0] === id) this.rso.choice_ids=[]
      else this.rso.choice_ids = [id]
      this.makeDelete()
    },
    makeDelete(){
      this.$set(this.rso, "_destroy", this.rso.choice_ids.length === 0)
    },

    available_spaces(choice) {
      return choice.spaces - choice.registrations_count
    },
    has_space(choice) {
      if (!choice.id)     return true;
      if (choice.spaces === null) return true;
      return choice.registrations_count < choice.spaces
    },
    isDisabled(choice) {
      if (choice.disabled !== undefined) return choice.disabled

      let val = this.disable_block_for_family;
      if (!val){
        const obj = new Addon(choice)
        val = this.disable_object_if_no_spaces({object: obj, registration: this.registration})
      }
      return choice.disabled =val
    },
    isReadOnly(choice) {
      if (choice.readonly !== undefined) return choice.readonly

      let val = this.isDisabled(choice);
      const checked = this.rso.choice_ids.length > 0
      // allowing family to uncheck field if we are allowed to edit sections based on allow_edit_sections.
      if (checked && this.registration.allow_edit_sections()) val = false
      return choice.readonly = val
    },
  },
  computed: {
    registration(){
      return this.state.current_reg
    },
    ability(){
      return new ValidTodayAbility(this.rso.section_option._attributes)
    },
  }
}
</script>
